<template>
    <Pagination
        class="pull-right no-margin vue-pagination"
        :class="{
            'disabled-box': options.disabled,
        }"
        :data="options"
        :limit="$root.paginator.settings.limit"
        :size="$root.paginator.settings.size"
        show-disabled
        @pagination-change-page="$emit('change-page', $event)"
    >
        <span slot="prev-nav">
            <i class="fa fa-angle-double-left"></i>
        </span>

        <span slot="next-nav">
            <i class="fa fa-angle-double-right"></i>
        </span>
    </Pagination>
</template>

<script>
export default {
    props: {
        options: {
            type: Object,
            required: true,
        },
    },
};
</script>
